import { ColorBox } from "devextreme-react";
import { useState } from "react";

import "./index.css";

export default function ColorComponent(props) {
  // const { color } = props.data.data;
  const { key } = props.data;

  const [color, setColor] = useState(props.data.data.color);

  const onValueChanged = ({ value }) => {
    setColor(value);

    props.data.component.getDataSource().store().update(key, {
      color: value,
    });

    props.data.component.getDataSource().reload();
  };

  return (
    <ColorBox
      id="projectColor"
      value={color}
      applyValueMode="useButtons"
      onValueChanged={onValueChanged}
    />
  );
}
